export default "__VITE_ASSET__3531e906__"